
import { FIELD_TYPE } from '@/constants'

import { setIncomeTotal } from './helper/incomeTotal'

export default [
  {
    label: 'Monthly Income',   
    type: FIELD_TYPE.HEADING
  }, 
  {
    apiKey: 'income.ssi',
    label: 'Social Security Income/SSI',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.ssdi',
    label: 'Social Security Disability Income/SSDI',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.tanf',
    label: 'Temporary Assistance for Needy Families/TANF',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.snapEBT',
    label: 'SNAP / EBT',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.mfipDwip',
    label: 'MFIP / DWIP ( Cash Assistance or Welfare )',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.employment',
    label: 'Employment/Job (total for the household)',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.unEmployment',
    label: 'Unemployment',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.childSupport',
    label: 'Child Support',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.other',
    label: 'Other',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setIncomeTotal(value, application) 
  }
  },
  {
    apiKey: 'income.total',
    label: 'Total Monthly Income',
    placeHolder: '',    
    disabled: true,
    type: FIELD_TYPE.CURRENCY
  },
  {
    apiKey: 'income.otherKnownIncome',
    label: 'Is there any other income you would like us to consider, if so, please describe them here:',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.TEXTAREA
  }
]